<template>
    <div class="free" >
        <p>月度预测</p>
        <hr/>
        <div class="top">
            <!-- 企业选择 -->
        <div class="inp1">
             <template>
                <Input v-model="value1">
                    <Select v-model="select1" slot="prepend" style="width: 80px"  placeholder="企业名称">
                        <Option value="business">企业名称</Option>
                        <Option value="boss">企业负责人</Option>
                        <Option value="homeNumber">户号</Option>
                    </Select>
                    <Button slot="append" >搜索</Button>
                </Input>
            </template>
        </div>


            <!-- 区域选择-->
        <div class="inp2">
            <template>
                <Dropdown>
                    <a href="javascript:void(0)">
                        河南省/全部
                        <span style="color:white">------</span>
                        <Icon type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list">
                        <DropdownItem>全部</DropdownItem>
                        <Dropdown placement="right-start">
                            <DropdownItem>
                                河南省
                                <Icon type="ios-arrow-forward"></Icon>
                            </DropdownItem>
                            <DropdownMenu slot="list">
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                        郑州市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>中原区</DropdownItem>
                                        <DropdownItem>金水区</DropdownItem>
                                        <DropdownItem>二七区</DropdownItem>
                                        <DropdownItem>上街区</DropdownItem>
                                        <DropdownItem>惠济区</DropdownItem>
                                        <DropdownItem>巩义市</DropdownItem>
                                        <DropdownItem>新郑市</DropdownItem>
                                        <DropdownItem>新密市</DropdownItem>
                                        <DropdownItem>登封市</DropdownItem>
                                        <DropdownItem>荥阳市</DropdownItem>
                                        <DropdownItem>中牟县</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                         开封市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>鼓楼区</DropdownItem>
                                        <DropdownItem>龙亭区</DropdownItem>
                                        <DropdownItem>顺河回族区</DropdownItem>
                                        <DropdownItem>禹王台区</DropdownItem>
                                        <DropdownItem>金明区</DropdownItem>
                                        <DropdownItem>开封县</DropdownItem>
                                        <DropdownItem>尉氏县</DropdownItem>
                                        <DropdownItem>兰考县</DropdownItem>
                                        <DropdownItem>杞县</DropdownItem>
                                        <DropdownItem>通许县</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                         洛阳市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>西工区</DropdownItem>
                                        <DropdownItem>老城区</DropdownItem>
                                        <DropdownItem>涧西区</DropdownItem>
                                        <DropdownItem>瀍河回族区</DropdownItem>
                                        <DropdownItem>洛龙区</DropdownItem>
                                        <DropdownItem>吉利区</DropdownItem>
                                        <DropdownItem>偃师市</DropdownItem>
                                        <DropdownItem>孟津县</DropdownItem>
                                        <DropdownItem>汝阳县</DropdownItem>
                                        <DropdownItem>伊川县</DropdownItem>
                                        <DropdownItem>洛宁县</DropdownItem>
                                        <DropdownItem>嵩县</DropdownItem>
                                        <DropdownItem>宜阳县</DropdownItem>
                                        <DropdownItem>新安县</DropdownItem>
                                        <DropdownItem>栾川县</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                         平顶山市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>新华区</DropdownItem>
                                        <DropdownItem>卫东区</DropdownItem>
                                        <DropdownItem>湛河区</DropdownItem>
                                        <DropdownItem>石龙区</DropdownItem>
                                        <DropdownItem>汝州市</DropdownItem>
                                        <DropdownItem>舞钢市</DropdownItem>
                                        <DropdownItem>宝丰县</DropdownItem>
                                        <DropdownItem>叶县</DropdownItem>
                                        <DropdownItem>郏县</DropdownItem>
                                        <DropdownItem>鲁山县</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                         安阳市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>北关区</DropdownItem>
                                        <DropdownItem>文峰区</DropdownItem>
                                        <DropdownItem>殷都区</DropdownItem>
                                        <DropdownItem>龙安区</DropdownItem>
                                        <DropdownItem>林州市</DropdownItem>
                                        <DropdownItem>安阳县</DropdownItem>
                                        <DropdownItem>滑县</DropdownItem>
                                        <DropdownItem>内黄县</DropdownItem>
                                        <DropdownItem>汤阴县</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                         鹤壁市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>淇滨区</DropdownItem>
                                        <DropdownItem>山城区</DropdownItem>
                                        <DropdownItem>鹤山区</DropdownItem>
                                        <DropdownItem>浚县</DropdownItem>
                                        <DropdownItem>淇县</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <Dropdown placement="right-start">
                                    <DropdownItem>
                                         新乡市
                                        <Icon type="ios-arrow-forward"></Icon>
                                    </DropdownItem>
                                    <DropdownMenu slot="list">
                                        <DropdownItem>全部</DropdownItem>
                                        <DropdownItem>卫滨区</DropdownItem>
                                        <DropdownItem>红旗区</DropdownItem>
                                        <DropdownItem>凤泉区</DropdownItem>
                                        <DropdownItem>牧野区</DropdownItem>
                                        <DropdownItem>卫辉市</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                                <DropdownItem>
                                    濮阳市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    许昌市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    漯河市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    三门峡市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    南阳市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    商丘市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    信阳市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    周口市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    驻马店市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>
                                <DropdownItem>
                                    济源市
                                    <Icon type="ios-arrow-forward"></Icon>
                                </DropdownItem>

                            </DropdownMenu>
                        </Dropdown>
                    </DropdownMenu>
                </Dropdown>
            </template>
        </div>
        <!-- 日期选择 -->

        <div class="inp3 ">
            <template>
                <Row>
                    <Col span="12">
                        <DatePicker type="month" placeholder="选择时间" style="width: 200px"></DatePicker>
                    </Col>
                </Row>
            </template>
            <!-- <div class="btn-group">
                <button type="button" style="width:200px;height:35px" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span style="float:right;" class="glyphicon glyphicon-calendar"></span>
                </button>
                <ul class="dropdown-menu">
                    <li><a href="#">Action</a></li>
                    <li role="separator" class="divider"></li>
                    <li>
                        <div class="spanBox">
                            <span>1月</span>
                            <span>2月</span>
                            <span>3月</span>
                            <span>4月</span>
                            <span>5月</span>
                            <span>6月</span>
                            <span>7月</span>
                            <span>8月</span>
                            <span>9月</span>
                            <span>10月</span>
                            <span>11月</span>
                            <span>12月</span>
                        </div>

                    </li>
                </ul>
            </div> -->

        </div>
        <div class="inp4">
            <template>
                    <Select v-model="select3" slot="prepend" style="width: 80px" placeholder="请选择预测人">
                        <Option value="people">全部</Option>
                        <Option value="people1">王明</Option>
                        <Option value="people2">师倩</Option>
                        <Option value="people3">许海峰</Option>
                    </Select>
            </template>
        </div>
            <template>
                <Table :columns="columns1" :data="data1"></Table>
            </template>
        </div>

        <div class="">


        </div>
            <!-- 时间选择器 -->
            <!-- <div class="container">
                <form class="card p-2">
                    <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="policyNo">保单号</label>
                        <input type="text" class="form-control" id="policyNo" placeholder="保单号">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="busCode">业务代码</label>
                        <input type="text" class="form-control" id="busCode" placeholder="业务代码">
                    </div>
                    <div class="form-group col-md-6">
                        <label for="startTime">开始日期</label>
                        <date-picker :date="startTime" :option="option" :limit="limit" id="startTime"></date-picker>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="endTime">结束日期</label>
                        <date-picker :date="endTime" :option="option" :limit="limit" id="endTime"></date-picker>
                    </div>

                    <div class="form-group row">
                    <div class="col-sm-10">
                        <button type="submit" class="btn btn-primary">查询</button>
                    </div>
                    </div>
                    </div>
                </form>
            </div> -->
    </div>


</template>

<script>
    //引入bootstrap
    import 'bootstrap/dist/js/bootstrap.min.js'
    import 'bootstrap/dist/css/bootstrap.min.css'
    import {HOST} from '@/config';

    import Datepicker from 'vue-datepicker/vue-datepicker-es6.vue'
    export default {
        name: 'free',
        components: {
           'date-picker': Datepicker
        },
        data() {
            return {
                value1:"",
                select1:'企业名称',
                // 以下为表格数据

                columns1: [
                    {
                        title: '标记',
                        key: 'name'
                    },
                    {
                        title: '客户名称',
                        key: "khmc"
                    },
                    {
                        title: '09月实际电量',
                        key: 'dl1'
                    },{
                        title: '10月申报电量',
                        key: 'dl2'
                    },
                    {
                        title: '11月历史电量',
                        key: 'dl3'
                    },{
                        title: '11月申报电量',
                        key: 'dl4'
                    },
                    {
                        title: '11月预测电量',
                        key: 'dl5'
                    },{
                        title: '环比偏差',
                        key: 'dl6',
                        sortable: true
                    },
                    {
                        title: '同比偏差',
                        key: 'dl7',
                        sortable: true
                    },{
                        title: '申报偏差',
                        key: 'dl8',
                        sortable: true
                    }
                ],
                data1: [
                    {
                        name: '……',
                        khmc: "JACK",
                        dl1: '111',
                        dl2: '222',
                        dl3: '333',
                        dl4: '444',
                        dl5: '555',
                        dl6: '666',
                        dl7: '777',
                        dl8: '888',
                    },
                    {
                        name: '!',
                        khmc: "ais",
                        dl1: '1111111',
                        dl2: '22222222',
                        dl3: '33333333',
                        dl4: '444444444',
                        dl5: '555555555',
                        dl6: '66666666',
                        dl7: '7777777777',
                        dl8: '888888888',
                    },
                    {
                        name: '&&&',
                        khmc: "dfs",
                        dl1: 'aaaaaa111',
                        dl2: '222ssssssssss',
                        dl3: '333dddddddd',
                        dl4: 'gggggggg444',
                        dl5: 'hhhh555',
                        dl6: '666jjjjjjjjj',
                        dl7: '777kkkkk',
                        dl8: '888wwwwwww',
                    },
                ],










                msg:'企业名称',
                startTime: {
                    time: ''
                },
                endTime: {
                    time: ''
                },
                option: {
                    type: 'day',
                    week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
                    month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    format: 'YYYY-MM-DD HH:mm',
                    placeholder: '请输入日期',
                    inputStyle: {
                        'display': 'inline-block',
                        'padding': '4px',
                        'line-height': '17px',
                        'font-size': '14px',
                        'width': '190px',
                        'border': '1px solid #ddd',
                        // 'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
                        'border-radius': '5px',
                        'color': '#5F5F5F'
                    },
                    color: {
                        header: '#ccc',
                        headerText: '#f00'
                    },
                    buttons: {
                        ok: '确定',
                        cancel: '取消'
                    },
                    overlayOpacity: 0.5, // 0.5 as default
                    dismissible: true // as true as default
                },
                timeoption: {
                    type: 'min',
                    week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
                    month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    format: 'YYYY-MM-DD HH:mm'
                  },
                  multiOption: {
                    type: 'multi-day',
                    week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
                    month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                    format: 'YYYY-MM-DD HH:mm'
                  },
                   limit: [{
                      type: Array,
                      default:function _default(){
                        return [];
                      }
                    }]
            }
        }
    }
    // export default {
    //     name: 'free',
    //     data() {
    //         return {
    //             msg:'企业名称',

    //         }
    //     },
    //     methods:{
    //         changeTop:function(){
    //             console.log("aa")
    //         }
    //     },
    //     mounted:function(){

    //     }


    // }
</script>

<style scoped>
    .body{
        background-color: #f2f2f2;
        font-size: 14px;
    }
    .top{
        height:37px;
        border:1px solid black
    }
     .inp1, .inp2, .inp3, .inp4{
        /* border:1px solid black; */
        display:inline-block;

    }
    .inp2{
        border:1px solid #D3D3D3;
        height:34px;
        border-radius: 5px;
        position:relative;
        top:-10px;
        line-height: 34px;
        padding:0 10px
    }
    .inp4{
        position:relative;
        top:-12px;
    }


</style>



// WEBPACK FOOTER //
// src/components/free.vue